import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Sidebar from "./Sidebar";

export default function AppLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  return (
    <>
      <div
        className={[
          "appShell",
          sidebarOpen ? "appShell--sidebarOpen" : "appShell--sidebarClosed",
        ].join(" ")}
      >
        <Sidebar
          open={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
          onOpen={() => setSidebarOpen(true)}
        />
        <main className="appShell__content">
          <Outlet />
        </main>
      </div>
      <ToastContainer />
    </>
  );
}
